import Dynamicore, { SERVICES } from 'services/dynamicore';
import {
  AWS_BUCKET as BUCKET,
  AWS_REGION as REGION,
} from 'settings/aws';

export async function checkKeyExist(path, repository = BUCKET) {
  path = path.replace(`https://${repository}.s3.${REGION}.amazonaws.com/`, '');
  const [company, ...key] = path.replace('company/', '').split('/');

  const checkFile = await Dynamicore(SERVICES.USERS_CHECK_DOCUMENT).post({
    bucket: repository,
    company,
    key: `/${key.join('/')}`,
  });

  return checkFile;
}

/**
* Download file from AWS S3
*
* @param {string} path
*/
export async function download(path, sign = true) {
  const win = window.open('about:blank', '_blank');
  try {
    const url = sign
      ? await getSignedUrl(path)
      : path;

    if (win) {
      win.location = url;
      setTimeout(() => {
        win.close();     
      }, 5000);
    } else {
      window.open(url, '_blank');
    }
  } catch (error) {
    if (win) {
      win.close();
    }
    return false;
  }

  return true;
}

export async function download2(path, sign = true) {
  try {

    const url = sign
      ? await getSignedUrl(path)
      : path;

    // Descarga el archivo usando fetch
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Error al descargar el archivo: ${response.statusText}`);
    }

    // Convierte la respuesta a un Blob
    const blob = await response.blob();

    // Crea un objeto File a partir del Blob
    const [fileName] = (path.split('/').pop() || '').split('?'); // Extraer el nombre del archivo de la URL
    const file = new File([blob], fileName, {
      type: blob.type,
    });

    return file;
  } catch (error) {
    return false;
  }
}

/**
 * Get signed URL
 *
 * @param {object|string} document - Document object or URL string
 * @param {number} expires - Expiration time
 * @param {string} repository - Repository name
 */
export async function getSignedUrl(
  document,
  expires = 10,
  repository = BUCKET,
) {

  const companyData = JSON.parse(localStorage.getItem('company'));
  const companyId = companyData?.id;

  if (typeof document === 'string') {
    const path = document.replace(
      `https://${repository}.s3.${REGION}.amazonaws.com/`,
      '',
    );
    const urlParts = path.split('/');
    const companyIndex = urlParts.indexOf('company');
    
    let extractedCompany = companyId;
    if (companyIndex !== -1 && urlParts.length > companyIndex + 1) {
      extractedCompany = urlParts[companyIndex + 1];
    }
    
    const key =
      companyIndex !== -1
        ? `/${urlParts.slice(companyIndex + 2).join('/')}`
        : `/${path}`;

    return await Dynamicore(SERVICES.USERS_SIGNIN_DOCUMENT).post({
      bucket: repository,
      company: extractedCompany,
      expires,
      key,
    });
  }

  if (document?.custom === true) {
    return await Dynamicore(SERVICES.USERS_SIGNIN_DOCUMENT).post({
      bucket: document.bucket,
      company: companyId,
      expires: 1000,
      url: document.url,
      custom: true,
      region: document.region,
    });
  }

  const path = (document.url ?? '').replace(
    `https://${repository}.s3.${REGION}.amazonaws.com/`,
    '',
  );
  const urlParts = path.split('/');
  const companyIndex = urlParts.indexOf('company');
  
  let extractedCompany = companyId;
  if (companyIndex !== -1 && urlParts.length > companyIndex + 1) {
    extractedCompany = urlParts[companyIndex + 1];
  }
  
  const key =
    companyIndex !== -1
      ? `/${urlParts.slice(companyIndex + 2).join('/')}`
      : `/${path}`;

  return await Dynamicore(SERVICES.USERS_SIGNIN_DOCUMENT).post({
    bucket: repository,
    company: extractedCompany,
    expires,
    key,
  });
}

/**
* Upload file to AWS S3
*
* @param {string} path
* @param {(Buffer|Uint8Array|Blob|string|Readable)} file
* @param {object} metadata
*/
export async function upload(path, file, metadata = {}, company) {
  if (path.startsWith('company/')) {
    [, company] = path.split('/');
    path = path.replace(`company/${company}`, '');
  }

  const presigned = await Dynamicore(SERVICES.USERS_PRESIGNIN_DOCUMENT).post({
    bucket: BUCKET,
    company,
    expires: 60 * 10,
    key: path,
  });

  const formData = new FormData();
  Object.entries(presigned.fields).forEach(([k, v]) => {
    formData.append(k, v);
  });
  formData.append('file', new Blob([file]));

  await fetch(presigned.url, {
    method: 'POST',
    body: formData,
  });

  return {
    Location: `https://${BUCKET}.s3.${REGION}.amazonaws.com/${presigned.fields.key}`,
  };
}
